// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-698ca7e9]{width:100%;display:flex;justify-content:center}.banner[data-v-698ca7e9]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
